import { type WorkspaceOrg, WorkspaceSelector } from "@pej/kore/components";
import { useState } from "react";
import { CreateWorkspaceDialog } from "@/components/selector/create-workspace-dialog";
import { useOpenCreatedWorkspace } from "@/contexts/use-open-created-workspace";
import { useWorkspaceContext } from "@/contexts/workspace-context";
import { getOrgColor } from "@/lib/org/org-color";

// Thin adapter over kore's WorkspaceSelector: one group per organization,
// and "New workspace in <org>" opens the create dialog in place.
export function WorkspacePicker() {
    const { workspaceId, selectorGroups, setWorkspace } = useWorkspaceContext();
    const openCreatedWorkspace = useOpenCreatedWorkspace();
    const [createIn, setCreateIn] = useState<{ id: string; name: string } | null>(null);

    const orgs: WorkspaceOrg[] = selectorGroups.map((g) => ({
        key: g.organization.id,
        name: g.organization.name,
        hue: getOrgColor(g.organization.colorIndex).bg,
        canCreate: g.canCreateWorkspace,
        workspaces: g.workspaces.map((w) => ({ key: w.id, name: w.name })),
    }));

    return (
        <>
            <WorkspaceSelector
                orgs={orgs}
                currentWorkspaceKey={workspaceId || null}
                onSelectWorkspace={setWorkspace}
                onCreateWorkspace={(orgKey) => {
                    const group = selectorGroups.find((g) => g.organization.id === orgKey);
                    if (group) setCreateIn({ id: group.organization.id, name: group.organization.name });
                }}
                className="w-full"
            />
            <CreateWorkspaceDialog
                organization={createIn}
                onOpenChange={(open) => {
                    if (!open) setCreateIn(null);
                }}
                onCreated={async (id) => {
                    setCreateIn(null);
                    await openCreatedWorkspace(id);
                }}
            />
        </>
    );
}
